import { Link } from 'react-router-dom';

// Codex Phase G — explicit 404 for unknown routes (replaces the silent
// wildcard that left users on a blank screen).
export default function NotFound() {
  return (
    <div
      data-testid="not-found-page"
      className="min-h-screen flex flex-col items-center justify-center bg-[#F7F5F1] px-6 text-center"
    >
      <p className="text-sm tracking-[0.3em] text-[#9A9488] uppercase mb-4">Error 404</p>
      <h1 className="text-4xl sm:text-5xl font-serif text-[#0D0D0D] mb-3">
        This page slipped off the rail
      </h1>
      <p className="text-base text-[#4A463E] max-w-md mb-8">
        The page you’re looking for doesn’t exist or has moved. Let’s get you
        back to something stylish.
      </p>
      <Link
        to="/"
        data-testid="not-found-home-link"
        className="inline-flex items-center px-6 py-3 rounded-full bg-[#0D0D0D] text-white text-sm font-medium hover:bg-[#2A2A2A] transition-colors"
      >
        Back to StyleGenome
      </Link>
    </div>
  );
}
